// src/pages/PendingSellers.js
import React, { useState, useEffect } from 'react';
import api from '../api';

const PendingSellers = () => {
  const [pendingSellers, setPendingSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [approvalInfo, setApprovalInfo] = useState({}); // To store royalty fee for each seller

  // Fetch pending sellers on component mount
  useEffect(() => {
    const fetchPendingSellers = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get('/admin/pending-sellers', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPendingSellers(response.data);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch pending sellers.');
      } finally {
        setLoading(false);
      }
    };

    fetchPendingSellers();
  }, []);

  // Update royalty fee in state
  const handleApprovalChange = (sellerId, value) => {
    setApprovalInfo((prev) => ({ ...prev, [sellerId]: value }));
  };

  // Approve seller
  const approveSeller = async (sellerId) => {
    const royaltyFee = approvalInfo[sellerId];
    if (!royaltyFee || isNaN(royaltyFee) || Number(royaltyFee) < 0) {
      alert('Please enter a valid positive number for royalty fee.');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await api.post('/admin/approve-seller', {
        sellerId,
        royaltyFee: Number(royaltyFee),
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Remove the seller from the pending list
      setPendingSellers((prev) => prev.filter((seller) => seller._id !== sellerId));
      alert('Seller approved successfully.');
    } catch (err) {
      console.error(err);
      alert('Failed to approve seller.');
    }
  };

  // Reject seller
  const rejectSeller = async (sellerId) => {
    if (!window.confirm('Are you sure you want to reject this seller?')) return;
    try {
      const token = localStorage.getItem('token');
      await api.post('/admin/reject-seller', { sellerId }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Remove the seller from the pending list
      setPendingSellers((prev) => prev.filter((seller) => seller._id !== sellerId));
      alert('Seller rejected successfully.');
    } catch (err) {
      console.error(err);
      alert('Failed to reject seller.');
    }
  };

  if (loading) return <div>Loading pending sellers...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="container mt-5">
      <h2>Pending Sellers</h2>
      {pendingSellers.length === 0 ? (
        <p>No pending sellers to approve.</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Company Name</th>
              <th>Phone Number</th>
              <th>Company Address</th>
              <th>Refund Email</th>
              <th>Royalty Fee (%) <span className="text-danger">*</span></th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pendingSellers.map((seller) => {
              // Construct the company address string if available
              const address = seller.companyAddress
                ? `${seller.companyAddress.street || ''}, ${seller.companyAddress.city || ''}, ${seller.companyAddress.zip || ''}`
                : 'N/A';
              return (
                <tr key={seller._id}>
                  <td>{seller.name}</td>
                  <td>{seller.email}</td>
                  <td>{seller.companyName}</td>
                  <td>{seller.phoneNumber || 'N/A'}</td>
                  <td>{address}</td>
                  <td>{seller.refundEmail || 'N/A'}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      placeholder="Royalty Fee"
                      value={approvalInfo[seller._id] || ''}
                      onChange={(e) => handleApprovalChange(seller._id, e.target.value)}
                    />
                  </td>
                  <td>
                    <button className="btn btn-success me-2" onClick={() => approveSeller(seller._id)}>
                      Approve
                    </button>
                    <button className="btn btn-danger" onClick={() => rejectSeller(seller._id)}>
                      Reject
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PendingSellers;
